import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_97nhawnvjk: FaireBrandEntity = {
  token: "b_97nhawnvjk",
  type: "brand",
  name: "Deluxe Import Trading",
  avatarUrl:
    "https://cdn.faire.com/fastly/a71cbc9b1efc057badc3e7f8855086187a38f460bfb86696d8c9a6f42ca067f7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/91e403cfa5bab1d8d710842431f09f0d85cc37c52da8b865c1b90758b1c607a2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a71cbc9b1efc057badc3e7f8855086187a38f460bfb86696d8c9a6f42ca067f7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/91e403cfa5bab1d8d710842431f09f0d85cc37c52da8b865c1b90758b1c607a2.jpeg",
  location: "Carson, CA, USA",
  minimumOrderDollars: 40,
  rating: 4.3,
  reviewCount: 189,
  isInsider: true,
  description:
    "Deluxe Import Trading is a family-owned business 35 years in the making. We have grown from selling auto parts and stereo equipment at swap meets in the 1980’s to be a leader in wholesale general merchandise and impulse programs in the United States today. We now are a trusted vendor of independent retailers and chain supermarkets, dollar stores, department stores, gas stations and more.\n\nOur mission has always been to supply high-quality low-cost goods to our customers because we know that your success is our success. We take pride in our reputation of quality products, friendly customer service and reliability.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:03.057Z",
    importedBy: "entity-db-cli",
  },
};
